import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import { ALIGN_PROPS } from './UIColumnConstants';
import UIAbstractColumn from './abstract/UIAbstractColumn';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIColumnWrapper(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIAbstractColumn, Object.assign({}, props, {
    columnType: "wrapper",
    children: children
  }));
}
UIColumnWrapper.propTypes = {
  align: PropTypes.oneOf(ALIGN_PROPS),
  alignSelf: PropTypes.oneOf(ALIGN_PROPS),
  children: PropTypes.node
};
UIColumnWrapper.defaultProps = {
  align: 'start'
};
UIColumnWrapper.displayName = 'UIColumnWrapper';